exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".login-fields .q-if-error:before,.login-fields .q-if-label,.q-if-error:after,.q-if-error:not(.q-if-inverted) .q-if-label{color:#524f5a!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0eb84fa7","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/pages/auth/login.vue
// module id = IVzw
// module chunks = 44